import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Star } from "lucide-react";
import { toast } from "sonner";

const SAMPLE_REVIEWS = [
  { name_ar: "أحمد م.", name_en: "Ahmed M.", rating: 5,
    comment_ar: "حافظة جلد رائعة جداً، الجودة عالية والتوصيل سريع.", comment_en: "Amazing leather case, premium quality and fast delivery." },
  { name_ar: "سارة ع.", name_en: "Sara A.", rating: 5,
    comment_ar: "الباور بانك يشحن بسرعة جنونية، مستحق كل درهم.", comment_en: "The power bank charges insanely fast. Worth every dirham." },
  { name_ar: "خالد ر.", name_en: "Khalid R.", rating: 4,
    comment_ar: "شاشة حماية سفير حلوة جداً، تركيب سهل.", comment_en: "Sapphire screen protector is gorgeous, easy install." },
];

export default function Reviews() {
  const { t, lang } = useLanguage();
  const [name, setName] = useState("");
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [submitted, setSubmitted] = useState([]);

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim() || !comment.trim()) return;
    setSubmitted((s) => [{ name_ar: name, name_en: name, rating, comment_ar: comment, comment_en: comment }, ...s]);
    setName(""); setComment(""); setRating(5);
    toast.success(lang === "ar" ? "شكراً على تقييمك!" : "Thanks for your review!");
  };

  const all = [...submitted, ...SAMPLE_REVIEWS];

  return (
    <div className="max-w-3xl mx-auto px-6 py-16 page-enter" data-testid="reviews-page">
      <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-2">M16</div>
      <h1 className="font-display text-4xl mb-3">{t("reviews")}</h1>
      <p className="text-[#9CA3AF] mb-10">
        {lang === "ar" ? "آراء عملائنا الكرام تهمّنا. شاركنا تجربتك مع M16." : "Your feedback shapes us. Share your M16 experience."}
      </p>

      <form onSubmit={submit} className="bg-[#121214] border border-[#27272A] rounded-2xl p-6 mb-10 space-y-4" data-testid="review-form">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("name")}
          className="input-luxe"
          data-testid="review-name-input"
        />
        <div className="flex items-center gap-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => setRating(n)}
              data-testid={`review-star-${n}`}
              className={`p-1.5 transition-colors ${n <= rating ? "text-[#D4AF37]" : "text-[#27272A] hover:text-[#9CA3AF]"}`}
            >
              <Star size={22} fill={n <= rating ? "#D4AF37" : "none"} />
            </button>
          ))}
        </div>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={lang === "ar" ? "اكتب تقييمك..." : "Write your review..."}
          rows={3}
          className="input-luxe resize-none"
          data-testid="review-comment-input"
        />
        <button type="submit" className="btn-gold px-6 py-2.5 rounded-full" data-testid="review-submit-btn">
          {lang === "ar" ? "إرسال التقييم" : "Submit review"}
        </button>
      </form>

      <div className="space-y-4">
        {all.map((r, i) => (
          <div key={i} className="bg-[#121214] border border-[#27272A] rounded-xl p-5">
            <div className="flex items-center justify-between mb-2">
              <div className="font-display">{lang === "ar" ? r.name_ar : r.name_en}</div>
              <div className="flex">
                {[1,2,3,4,5].map((n) => (
                  <Star key={n} size={14} className="text-[#D4AF37]" fill={n <= r.rating ? "#D4AF37" : "none"} />
                ))}
              </div>
            </div>
            <p className="text-sm text-[#F3F4F6]/85 leading-relaxed">{lang === "ar" ? r.comment_ar : r.comment_en}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
